import {parseHeaderToMarkdown} from './parsers/HeaderTypeParser';
import {parseParagraphToMarkdown} from './parsers/ParagraphTypeParser';
import {parseListToMarkdown} from './parsers/ListTypeParser';
import {parseDelimiterToMarkdown} from './parsers/DelimiterTypeParser';
import {parseImageToMarkdown} from './parsers/ImageTypeParser';
import {parseQuoteToMarkdown} from './parsers/QuoteTypeParser';
import {parseCodeToMarkdown} from './parsers/CodeTypeParser';
import {parseTableToMarkdown} from "./parsers/TableTypeParser";
import {parseLinkToolToMarkdown} from "./parsers/LinkToolTypeParser";
import {parseEmbedToMarkdown} from "./parsers/EmbedTypeParser";
import {parseWarningToMarkdown} from "./parsers/WarningTypeParser";
import {parseToggleToMarkdown} from "./parsers/ToggleTypePaser";
import {convertTiptapToMarkdown, isTiptapDoc} from "./tiptap-parser";

export {convertTiptapToMarkdown, isTiptapDoc, extractSmartBlockLines} from "./tiptap-parser";

export const convertJsonToMarkdown = (data) => {
  // Discriminator (Faz 4.2): Tiptap doc → tiptap-parser; legacy EditorJS
  // (blocks[]) → mevcut parser'lar. Metastory panel footer'ı iki formatta ortak.
  let markdown = '';
  if (isTiptapDoc(data)) {
    markdown = convertTiptapToMarkdown(data);
  } else if (data && data.blocks && data.blocks.length) {
    markdown = parseBlocksToMarkdown(data.blocks).join('\n');
  }

  if (!markdown) {
    return "";
  }

  // Add the custom panel with a link at the end of the document
  markdown += `\n{panel:title=metastory AI|bgColor=#E8E7FF}\n`;
  markdown += '[*metastory AI* · Empowering Product Owner with AI|https://metastory.ai/]\n';
  markdown += '{panel}';

  return markdown;
};

const parseBlocksToMarkdown = (blocks) => {
  return blocks.map((item) => parseBlockToMarkdown(item));
};

const parseBlockToMarkdown = (item) => {
  switch (item.type) {
    case 'smartBlock':
      return parseSmartBlockToMarkdown(item.data);
    case 'header':
    case 'paragraph':
    case 'list':
    case 'bulletedList':
    case 'numberedList':
    case 'checklist':
    case 'delimiter':
    case 'image':
    case 'quote':
    case 'code':
    case 'table':
    case 'linkTool':
    case 'embed':
    case 'toggle':
    case 'warning':
      return parseSpecificBlockToMarkdown(item);
    default:
      return '';
  }
};

const parseSmartBlockToMarkdown = (smartBlockData) => {
  let markdownOutput = '';

  // Check if the title exists and append it as formatted panel title
  if (smartBlockData.title) {
    markdownOutput += `{panel:title=${smartBlockData.title}|bgColor=#E8E7FF}\n`;
  }

  // Process the nested blocks if they exist
  if (smartBlockData.content && smartBlockData.content.blocks) {
    const contentMarkdown = parseBlocksToMarkdown(smartBlockData.content.blocks).join('\n');
    markdownOutput += contentMarkdown;
  }

  // Close the panel
  if (smartBlockData.title) {
    markdownOutput += '{panel}\n';
  }

  return markdownOutput;
};

const parseSpecificBlockToMarkdown = (item) => {
  if (item.type === 'bulletedList' && item.data.style === 'checklist') {
    return parseListToMarkdown({...item.data, style: 'checklist'});
  }

  if (item.type === 'bulletedList' && item.data.style === 'ordered') {
    return parseListToMarkdown({...item.data, style: 'ordered'});
  }

  switch (item.type) {
    case 'header':
      return parseHeaderToMarkdown(item.data);
    case 'paragraph':
      return parseParagraphToMarkdown(item.data);
    case 'list':
      return parseListToMarkdown({...item.data, style: 'unordered'});  // Ensure correct type is passed
    case 'bulletedList':
      return parseListToMarkdown({...item.data, style: 'unordered'});
    case 'numberedList':
      return parseListToMarkdown({...item.data, style: 'ordered'});
    case 'checklist':
      return parseListToMarkdown({...item.data, style: 'checklist'});
    case 'delimiter':
      return parseDelimiterToMarkdown(item);
    case 'image':
      return parseImageToMarkdown(item.data);
    case 'quote':
      return parseQuoteToMarkdown(item.data);
    case 'code':
      return parseCodeToMarkdown(item.data);
    case 'table':
      return parseTableToMarkdown(item.data);
    case 'linkTool':
      return parseLinkToolToMarkdown(item.data);
    case 'embed':
      return parseEmbedToMarkdown(item.data);
    case 'toggle':
      return parseToggleToMarkdown(item.data);
    case 'warning':
      return parseWarningToMarkdown(item.data);
    default:
      return '';
  }
};